import {Loading} from '@sede-enterprise/shell-ds-react-framework'
import { LoadingContainer } from './LoadingIndicator.styled'

export const LoadingIndicator = () =>{
    return(
        <LoadingContainer data-testid='LoadingIndicator' >
            <Loading type="default" size="large"  />
        </LoadingContainer>
    )
}